// 给所有 iframe 添加 pointer-events: none; 样式
function addPointerEventsNoneToIframes() {
  const iframes = document.querySelectorAll('iframe')
  iframes.forEach((iframe) => {
    iframe.style.pointerEvents = 'none'
  })
}

// 移除所有 iframe 的 pointer-events: none; 样式
function removePointerEventsNoneFromIframes() {
  const iframes = document.querySelectorAll('iframe')
  iframes.forEach((iframe) => {
    iframe.style.pointerEvents = '' // 设置为空字符串以移除样式
  })
}

// 暴露这两个函数作为模块的公共接口
export { addPointerEventsNoneToIframes, removePointerEventsNoneFromIframes }
